/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersForgotPasswordVerifyMutationRequest, PostUsersForgotPasswordVerifyMutationResponse, PostUsersForgotPasswordVerify400 } from "../entities/PostUsersForgotPasswordVerify";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { postUsersForgotPasswordVerify } from "../api/postUsersForgotPasswordVerify";
import { useMutation } from "@tanstack/react-query";

export const postUsersForgotPasswordVerifyMutationKey = () => [{ url: '/users/forgot-password/verify' }] as const

export type PostUsersForgotPasswordVerifyMutationKey = ReturnType<typeof postUsersForgotPasswordVerifyMutationKey>

/**
 * @description Подтверждение восстановления пароля
 * @summary Подтверждение
 * {@link /users/forgot-password/verify}
 */
export function usePostUsersForgotPasswordVerify<TContext>(options: 
{
  mutation?: UseMutationOptions<PostUsersForgotPasswordVerifyMutationResponse, ResponseErrorConfig<PostUsersForgotPasswordVerify400>, {data: PostUsersForgotPasswordVerifyMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostUsersForgotPasswordVerifyMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postUsersForgotPasswordVerifyMutationKey()

  return useMutation<PostUsersForgotPasswordVerifyMutationResponse, ResponseErrorConfig<PostUsersForgotPasswordVerify400>, {data: PostUsersForgotPasswordVerifyMutationRequest}, TContext>({
    mutationFn: async({ data }) => {
      return postUsersForgotPasswordVerify(data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}